// @flow
import React, { Component } from 'react';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';
import classNames from 'classnames';

// Components
import { Container, Row, Col } from 'reactstrap';
import InputField from 'components/atoms/InputField';

// Utils
import { LICENSE_NUMBER_REGEX } from 'utils/regex';

// Types
import { gtmUserEventType } from 'types/gtm';

import './LicenseNumberInput.scss';
const ns = 'license-input';

export type Props = {
  onlyView: boolean,
  isRegistrationNumEnabled: boolean,
  isLicenseNumberValid: boolean,
  isObfuscated: boolean,
  obfuscatedBy: string,
  intl: IntlShape,
  licenseNumber?: string,
  setLicenseNumber: (value: string) => void,
  resetObfuscatedContactInfo: () => void,
  setObfuscatedBy: (obfuscatedBy: ?string) => void,
  gtmUserEvent: gtmUserEventType
};

type State = {
  userIsWriting: boolean
};

class LicenseNumberInput extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    (this: any).onInputChange = this.onInputChange.bind(this);
    (this: any).onInputBlur = this.onInputBlur.bind(this);
    this.state = {
      userIsWriting: false
    };
  }

  onInputChange(event: Object) {
    const {
      isObfuscated,
      resetObfuscatedContactInfo,
      setObfuscatedBy,
      setLicenseNumber
    } = this.props;
    if (!isObfuscated) {
      const inputValue = event.target.value.toUpperCase();
      if (inputValue.length <= 10) {
        setLicenseNumber(inputValue);
        event.target.value = inputValue;
        this.setState({ userIsWriting: true });
      }
    } else {
      resetObfuscatedContactInfo();
      setObfuscatedBy(null);
    }
  }

  onInputBlur() {
    const { isLicenseNumberValid, gtmUserEvent } = this.props;
    this.setState({ userIsWriting: false });
    if (!isLicenseNumberValid) {
      gtmUserEvent(
        `Contact Info License Number Input`,
        'Typed',
        `Invalid License Number`,
        'GTM_CURRENT_PAGE > Contact Info'
      );
    }
  }

  render() {
    const {
      isRegistrationNumEnabled,
      isLicenseNumberValid,
      intl,
      licenseNumber,
      onlyView
    } = this.props;
    const { userIsWriting } = this.state;
    if (isRegistrationNumEnabled) {
      const containerClassName = classNames({ 'px-0': !onlyView });
      const inputClassName = classNames(ns, `contact-form-license-number`, {
        [`${ns}--invalid`]: !isLicenseNumberValid
      });
      const inputConf = {
        name: 'licenseNumber',
        value: licenseNumber,
        onChange: e => this.onInputChange(e),
        onBlur: () => this.onInputBlur()
      };
      return (
        <Container>
          <Row>
            <Col className={containerClassName}>
              {licenseNumber && onlyView && !userIsWriting ? (
                <p className={`${ns}__panel my-0`}>{licenseNumber}</p>
              ) : (
                <InputField
                  className={inputClassName}
                  placeholder={intl.formatMessage({
                    id: 'c8.review.registration.no'
                  })}
                  inputConf={inputConf}
                  maskReg={LICENSE_NUMBER_REGEX}
                  type={'text'}
                  leftAddonConf={{
                    addonValue: 'registration_no_car',
                    isGlyhicon: true
                  }}
                />
              )}
            </Col>
          </Row>
        </Container>
      );
    }
    return null;
  }
}

export default LicenseNumberInput;



// WEBPACK FOOTER //
// ./src/components/molecules/LicenseNumberInput/LicenseNumberInput.js